module.exports = __webpack_public_path__ + "img/栀子.ea5dc6e9.jpg";